import React,  { useEffect } from "react";
import { TextField, DialogContent, Dialog, Typography, Button } from "@material-ui/core";
import useStyles from "../styles";
import { checkDocument, setDocumentForms } from "../api";

const ConfirmDialog = ({handleState, hash}) => {
    const [state, setState] = handleState;
    const cl = useStyles()
    const handleClose = () => {
        setState(p=>({
            ...p,
            dialog: false,
            dialogData: {
                f1: '',
                f2: ''
            }
        }))
    }

    const handleConfirmReport = async () => {
        if (+state.dialogData.f1 + +state.dialogData.f2 !== +state.dialogData.priceCalc) {
            // alert('Сума f1 та f2 повинна дорівнювати розрахунку');
            return;
        }
        try {
            setState((p) => ({
                ...p,
                l: true,
            }));
            await setDocumentForms(hash, state.dialogData)
            const check = await checkDocument(hash)
            
            setState((p) => ({
                ...p,
                data: {
                    ...p.data,
                    status: 'CONFIRMED'
                },
                l: false,
                check
            }));
            handleClose()
        } catch (e) {
            console.error(e);
        }
    }

    const handleChange = (e) => {
        e.persist();
        e.stopPropagation();
        e.preventDefault();
        const { name, value } = e.target;
        const formName = name === 'f1' ? 'f2' : 'f1';
        const newValue = (+state.dialogData.priceCalc - parseFloat(+value || 0)).toFixed(2)

        if (newValue < 0 || Number.isNaN(+value)) {
            return;
        }
        
        setState((p) => ({
            ...p,
            dialogData: {
                ...p.dialogData,
                [name]: +parseFloat(+value || 0),
                [formName]: +newValue
            },
        }));
    }

    useEffect(() => {
        if (state.data && state.data.status === 2 && !state.dialog) {
            setState(p=>({
                ...p,
                dialog: true,
                dialogData: {
                    f1: p.debt ? 0 : state?.data?.transactions?.reduce((acc, transaction) => acc + (transaction.value || 0), 0) || 0,
                    f2: 0,
                    priceCalc: state?.data?.transactions?.reduce((acc, transaction) => acc + (transaction.value || 0), 0) || 0

                    //state?.data?.detail?.editedData?.reduce((acc, client) =>  acc + client.clientTotals.priceCalc, 0)
                }
            }))
        }
    }, [state.data]);

    return <Dialog open={state.dialog} onClose={handleClose}>
        <DialogContent className={cl.dialogContent}>
            <Typography variant="h6">Підтвердження даних</Typography>
            <Typography variant="body1">Розрахунок: {state?.dialogData?.priceCalc}</Typography>
            {state.debt && <TextField
                label="f1"
                name="f1"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                value={state.dialogData.f1}
                placeholder="0.00"
                onChange={handleChange}
            />}
            {state.debt && <TextField
                label="f2"
                name="f2"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                value={state.dialogData.f2}   
                placeholder="0.00"
                onChange={handleChange}
            />}
            <Button
                variant="contained"
                color="primary"
                style={{ marginTop: '16px',alignSelf: 'flex-end' }}
                onClick={handleConfirmReport}
                disabled={(+state.dialogData.f1 + (+state.dialogData.f2)) !== +state.dialogData.priceCalc}
            >
                Надіслати
            </Button>
        </DialogContent>
    </Dialog>
}

export default ConfirmDialog;
